import { SERIAL_NUMBER_REGEX } from '@extendedWarranty/constants';
import { addWeeks } from 'date-fns';
import * as Yup from 'yup';

const BulkSerialUploadSchema = Yup.object({
    installation_name: Yup.string().when('uploadByFile', {
        is: false,
        then: (schema) => schema.required('Required'),
        otherwise: (schema) => schema.optional(),
    }),
    date_installed: Yup.lazy(() =>
        Yup.date()
            .typeError('Invalid Date')
            .when('uploadByFile', {
                is: false,
                then: (schema) =>
                    schema.required('Required').max(addWeeks(new Date(), 2), "Date can't be further than 14 days"),
                otherwise: (schema) => schema.optional().nullable(),
            })
    ),
    serial_numbers: Yup.string().when('uploadByFile', {
        is: false,
        then: (schema) =>
            schema
                .test(
                    'validate-serial-number-format',
                    'Serial Numbers must be separated by a comma or new line and the format must match HQXXXXXXXXX.',
                    (value: string | undefined) => {
                        const values = value ? value.split(/[,\n\r]+/) : [];

                        return values.every((v) => SERIAL_NUMBER_REGEX.test(v));
                    }
                )
                .required('Required'),
        otherwise: (schema) => schema.optional(),
    }),

    extendedWarrantyFiles: Yup.array()
        .of(
            Yup.object().shape({
                file: Yup.mixed(),
                name: Yup.string(),
                isLoading: Yup.boolean().optional(),
                error: Yup.string()
                    .optional()
                    .test('isEmpty', (value, schema) => (!!value ? schema.createError({ message: value }) : true)),
            })
        )
        .when('uploadByFile', {
            is: true,
            then: (schema) => schema.min(1).required(),
            otherwise: (schema) => schema.optional(),
        }),
    uploadByFile: Yup.boolean().optional(),
    support: Yup.boolean().when('uploadByFile', {
        is: false,
        then: (schema) => schema.required('Required'),
        otherwise: (schema) => schema.optional(),
    }),
});

export { BulkSerialUploadSchema };
